import React, { Component } from 'react';
import {connect} from 'react-redux'
import {filterProducts ,sortProducts} from '../actions/productActions';



class Filter extends Component {
    state = {  }
    render() { 
        return (  
            !this.props.filteredProducts ? 
            <div>Loading...</div> :

           <div className = "filter"> 
            <div className = "filter-result">
              {this.props.filteredProducts.length} Products
            </div>
             <div className="filter-sort">
                
                Order{" "}
                <select value = {this.props.sort} onChange = {(e) =>
                             this.props.sortProducts(this.props.filteredProducts,e.target.value)}>
                    <option value="latest">Latest</option>
                    <option value="lowest">Price low to high</option>
                    <option value="highest">Price high to low</option>
                    </select>   
             </div>
             <div className="filter-size">
                 Filter{" "}
                 <select value = {this.props.size} onChange = {(e) => 
                                this.props.filterProducts(this.props.products,e.target.value)}>
                     <option value="">ALL</option>
                     <option value="XS">XS</option>
                     <option value="S">S</option>
                     <option value="M">M</option>
                     <option value="L">L</option>
                     <option value="XL">XL</option>


                 </select>
                 </div>  
             </div>    
        );
    }
}
 
export default connect( state => ({
    size : state.products.size,
    sort:state.products.sort,
    products: state.products.items,
    filteredProducts : state.products.filteredItems
}),{
    filterProducts,
    sortProducts
})(Filter);